import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: '100%',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.textBackground.light,
    padding: theme.spacing(4, 4, 14, 4),
  },
  footerWrapperV2: {
    display: 'flex',
    gap: theme.spacing(3),
    marginRight: theme.spacing(8),
  },
  customFooter: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: theme.spacing(4),
  },
  loadingContainer: {
    height: '100vh',
  },
  cloudAccountDetailWrapper: {
    padding: theme.spacing(4),
  },
  emptyStateContainer: {
    height: '100vh',
  },
}))
